import { render, staticRenderFns } from "./DynamicApi.vue?vue&type=template&id=4eb3d3d1&scoped=true"
import script from "./DynamicApi.vue?vue&type=script&lang=js"
export * from "./DynamicApi.vue?vue&type=script&lang=js"
import style0 from "./DynamicApi.vue?vue&type=style&index=0&id=4eb3d3d1&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4eb3d3d1",
  null
  
)

export default component.exports